import {doc} from './docs.js';

doc(
    "globalReverse",
    {
    },
    "When 1 is received from inlet, whole track is reversed. When 0 whole track is not reversed",
    () => 0,
    {
        inlets: 1
    });
export const globalReverse = (object) => {
    return ([reverse]) => {
        if (reverse) {
            object.sequencerEngine.reverse = true;
        } else {
            object.sequencerEngine.reverse = false;
        }
    };
};

doc(
    "loop",
    {
        "looping on":"",
        "loop length (bars)": ""
        
    },
    "When 1 is received in left inlet, looping starts. O stops loop and continues play",
    () => 0,
    {
        inlets: 2,
        isHot: true
    });
export const loop = (object, bars) => {
    return ([flag]) => {
        let _bars = bars() || 0;
        if (_bars === 0) {
            flag = false;
        }
        _bars = Math.pow(2, _bars)/8;
        if (flag) {
            object.sequencerEngine.startNewLoop(_bars);
        } else {
            object.sequencerEngine.looping = false;
        }
    };
};

